"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldShowQuickViewButton = void 0;
var defaultCustomerNotifiableEvents = {
  backInStock: false,
  onRelease: false,
  onPreorderLaunch: false,
  newlyInStock: false
};
var shouldShowQuickViewButton = exports.shouldShowQuickViewButton = function shouldShowQuickViewButton() {
  var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var isMadeToMeasure = product.isMadeToMeasure,
    outOfStock = product.outOfStock,
    isInStoreOnly = product.isInStoreOnly,
    type = product.type,
    isFabricByLength = product.isFabricByLength,
    price = product.price,
    _product$customerNoti = product.customerNotifiableEvents,
    _product$customerNoti2 = _product$customerNoti === void 0 ? defaultCustomerNotifiableEvents : _product$customerNoti,
    backInStock = _product$customerNoti2.backInStock,
    onRelease = _product$customerNoti2.onRelease,
    onPreorderLaunch = _product$customerNoti2.onPreorderLaunch,
    newlyInStock = _product$customerNoti2.newlyInStock;
  var isPreorderBackInStock = backInStock && outOfStock;
  var isFutureRelease = isPreorderBackInStock || onRelease || onPreorderLaunch || newlyInStock;
  var productHasPrice = (price === null || price === void 0 ? void 0 : price.now) != null && Number(price.now) !== 0;
  if (isMadeToMeasure || isFutureRelease || outOfStock || isInStoreOnly || type === 'asaf' || type === 'productSet' || type === 'bundle' || isFabricByLength || !productHasPrice) {
    return false;
  }
  return true;
};